import { Center, Loader, Stack, Text } from "@mantine/core";
import type { ReactNode } from "react";
import { useEffect } from "react";

import { useAuth } from "./AuthProvider";

/**
 * Gate that refuses to render its children until the user is authenticated.
 * Triggers a Keycloak redirect on first anonymous render so deep-links
 * land on the correct page after login.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const auth = useAuth();

  useEffect(() => {
    if (auth.status === "anonymous") {
      void auth.login();
    }
  }, [auth]);

  if (auth.status === "authenticated") {
    return <>{children}</>;
  }

  return (
    <Center h="100vh">
      <Stack align="center" gap="xs">
        <Loader />
        <Text c="dimmed" size="sm">
          {auth.status === "initializing" ? "Checking session…" : "Redirecting to sign-in…"}
        </Text>
      </Stack>
    </Center>
  );
}
